import { SaveSession, ToggleEmbedAutoscale } from "../../../../connection/create-event";
import {
	GetSessionsForEvent
	, UpdateBreakoutBannerImage
	, UpdateUseBreakoutBackgroundImage
	, JoinBreakoutRoom
	, GetBreakoutRoomUsage
	, LeaveBreakoutRoom
	, GetBreakoutRoomToken
	, GetBreakoutRoomTestInfo,
	UpdateSecondarySessionVideo,
	GetSecondarySessionVideo,
	DeleteSecondarySessionVideo,
	UpdateBreakoutBackgroundImage,
	GetOpenTokToken
} from "../../../../connection/sessions";
import { Action, AsyncAction } from "../../../../types/actions";
import {
	EBroadcastTypes,
	CreateVideo,
	DBSession,
	HomepageVideo,
	PageModule,
	PageModuleGroupModules,
	PageModuleType,
	SecondarySessionVideo,
	Session,
	SessionLayout,
	SessionVideoCustomizations,
} from "../../../../types/working-model";

export const LOAD_WORKING_SESSION = "LOAD_WORKING_SESSION";
export function loadWorkingSession(session: Session | null): Action {
	return {
		type: LOAD_WORKING_SESSION,
		payload: session
	};
}

export const CLEAR_WORKING_SESSION = "CLEAR_WORKING_SESSION";
export function clearWorkingSession(): Action {
	return {
		type: CLEAR_WORKING_SESSION,
		payload: null
	};
}

export const TOGGLE_PAGE_MODULE = "TOGGLE_PAGE_MODULE";
export function togglePageModule(module: PageModule): Action {
	return {
		type: TOGGLE_PAGE_MODULE,
		payload: module
	};
}

export const UPDATE_PAGE_MODULE = "UPDATE_PAGE_MODULE";
export function updatePageModule(module: PageModule): Action {
	return {
		type: UPDATE_PAGE_MODULE,
		payload: module
	};
}

export const SET_SESSION_LAYOUT = "SET_SESSION_LAYOUT";
export function setSessionLayout(options: SessionLayout): Action {
	return {
		type: SET_SESSION_LAYOUT,
		payload: options
	};
}

export const SET_SESSION_MODULES = "SET_SESSION_MODULES";
export function setSessionModules(modules: PageModule[]): Action {
	return {
		type: SET_SESSION_MODULES,
		payload: modules
	};
}

export const ADD_SESSION_PAGE_MODULE = "ADD_SESSION_PAGE_MODULE";
export function addSessionPageModule(page_module: PageModule): Action {
	return {
		type: ADD_SESSION_PAGE_MODULE,
		payload: page_module
	};
}

export const SET_SESSION_ACTIVE_MODULE = "SET_SESSION_ACTIVE_MODULE";
export function setSessionActiveModule(selected: PageModuleType): Action {
	return {
		type: SET_SESSION_ACTIVE_MODULE,
		payload: selected
	};
}

export const SET_SESSION_ACTIVE_MODULE_BY_ID = "SET_SESSION_ACTIVE_MODULE_BY_ID";
export function setSessionActiveModuleById(moduleId: number | null): Action {
	return {
		type: SET_SESSION_ACTIVE_MODULE_BY_ID,
		payload: moduleId
	};
}

export const SET_ACTIVE_SESSION_GROUP_MODULE = "SET_ACTIVE_SESSION_GROUP_MODULE";
export function setActiveSessionGroupModule(moduleGroupUuid: string | null): Action {
	return {
		type: SET_ACTIVE_SESSION_GROUP_MODULE,
		payload: moduleGroupUuid
	};
}

export const SET_SESSION_USE_NAV = "SET_SESSION_USE_NAV";
export function setSessionUseNav(useNav: boolean): Action {
	return {
		type: SET_SESSION_USE_NAV,
		payload: useNav
	};
}

export const GET_SESSIONS_FOR_EVENT = "GET_SESSIONS_FOR_EVENT";
export function getSessionsForEvent(token: string, uuid: string): AsyncAction {
	return {
		type: GET_SESSIONS_FOR_EVENT,
		promise: GetSessionsForEvent(token, uuid)
	};
}

export const UPDATE_SESSIONS_LIST_FOR_EVENT = "UPDATE_SESSIONS_LIST_FOR_EVENT";
export function updateSessionsListForEvent(session: DBSession): Action {
	return {
		type: UPDATE_SESSIONS_LIST_FOR_EVENT,
		payload: session
	};
}

export const UPDATE_SESSION = "UPDATE_SESSION";
export function updateSession(session: Session, token: string): AsyncAction {
	return {
		type: UPDATE_SESSION,
		promise: SaveSession(session, token),
	};
}

export const UPDATE_WORKING_SESSION = "UPDATE_WORKING_SESSION";
export function updateWorkingSession(session: Session): Action {
	return {
		type: UPDATE_WORKING_SESSION,
		payload: session,
	};
}

export const UPDATING_SESSION = "UPDATING_SESSION";
export function updatingSession(isUpdating: boolean): Action {
	return {
		type: UPDATING_SESSION,
		payload: isUpdating,
	};
}

export const UPDATE_MODULE_GROUPINGS = "UPDATE_MODULE_GROUPINGS";
export function updateGroupModules(moduleGroupings: PageModuleGroupModules): Action {
	return {
		type: UPDATE_MODULE_GROUPINGS,
		payload: moduleGroupings,
	};
}

export const UPDATE_SESSION_STYLING = "UPDATE_SESSION_STYLING";
export function updateSessionStyling(styling: Session['layout']['styling_overrides']): Action {
	return {
		type: UPDATE_SESSION_STYLING,
		payload: styling
	};
}

export const SET_ON_DEMAND_VIDEO = "SET_ON_DEMAND_VIDEO";
export function setOnDemandVideo(video: CreateVideo | HomepageVideo): Action {
	return {
		type: SET_ON_DEMAND_VIDEO,
		payload: video
	};
}

export const SET_SESSION_BROADCAST_TYPE = "SET_SESSION_BROADCAST_TYPE";
export function setSessionBroadcastType(type: EBroadcastTypes): Action {
	return {
		type: SET_SESSION_BROADCAST_TYPE,
		payload: type
	};
}

export const SET_VIDEO_CUSTOMIZATIONS = "SET_VIDEO_CUSTOMIZATIONS";
export function setVideoCustomizations(customizations: SessionVideoCustomizations): Action {
	return {
		type: SET_VIDEO_CUSTOMIZATIONS,
		payload: customizations
	};
}

export const UPDATE_MODERATION_SETTINGS = "UPDATE_MODERATION_SETTINGS";
export function updateModerationSettings(settings: {
	posts: boolean;
	questions: boolean;
	chat: boolean;
}): Action {
	return {
		type: UPDATE_MODERATION_SETTINGS,
		payload: settings
	};
}

export const UPDATE_SHOULD_RECORD = "UPDATE_SHOULD_RECORD";
export function updateShouldRecord(on: boolean): Action {
	return {
		type: UPDATE_SHOULD_RECORD,
		payload: on
	};
}

export const TOGGLE_DISPLAY_VIEW_COUNT = "TOGGLE_DISPLAY_VIEW_COUNT";
export function toggleDisplayViewCount(isOn: boolean): Action {
	return {
		type: TOGGLE_DISPLAY_VIEW_COUNT,
		payload: isOn
	};
}

export const SET_SESSION_CSS = "SET_SESSION_CSS";
export function setSessionCss(css: string): Action {
	return {
		type: SET_SESSION_CSS,
		payload: css
	};
}

export const SET_SESSION_COMPILED_CSS = "SET_SESSION_COMPILED_CSS";
export function setSessionCompiledCss(css?: string): Action {
	return {
		type: SET_SESSION_COMPILED_CSS,
		payload: css
	};
}

export const SET_SESSION_USE_SAFE_CSS = "SET_SESSION_USE_SAFE_CSS";
export function setSessionUseSafeCss(on: boolean): Action {
	return {
		type: SET_SESSION_USE_SAFE_CSS,
		payload: on
	};
}

export const REMOVE_SESSION_FROM_CREATE_SESSION = 'REMOVE_SESSION_FROM_CREATE_SESSION';
export function removeSessionFromCreateSessionReducer(sessionID: number, eventUuid: string): Action {
	return {
		type: REMOVE_SESSION_FROM_CREATE_SESSION,
		payload: { sessionID, eventUuid },
	};
}

export const UPDATE_BREAKOUT_BANNER_IMAGE = "UPDATE_BREAKOUT_BANNER_IMAGE";
export function updateBreakoutBannerImage(image: string | null, sessionId: number, token: string): AsyncAction {
	return {
		type: UPDATE_BREAKOUT_BANNER_IMAGE,
		promise: UpdateBreakoutBannerImage(image, sessionId, token),
	};
}


export const UPDATE_USE_BREAKOUT_IMAGE = "UPDATE_USE_BREAKOUT_IMAGE";
export function updateUseBreakoutImage(updated: boolean, sessionId: number, token: string): AsyncAction {
	return {
		type: UPDATE_USE_BREAKOUT_IMAGE,
		promise: UpdateUseBreakoutBackgroundImage(updated, sessionId, token),
	};
}

export const UPDATE_BREAKOUT_BACKGROUND_IMAGE = "UPDATE_BREAKOUT_BACKGROUND_IMAGE";
export function updateBreakoutBackgroundImage(image: string | null, sessionId: number, token: string): AsyncAction {
	return {
		type: UPDATE_BREAKOUT_BACKGROUND_IMAGE,
		promise: UpdateBreakoutBackgroundImage(image, sessionId, token),
	};
}

// opentok actions
export const JOIN_BREAKOUT_ROOM = "JOIN_BREAKOUT_ROOM";
export function joinBreakoutRoom(sessionUuid: string, breakoutUuid: string, token: string, opentokId: string | null): AsyncAction {
	return {
		type: JOIN_BREAKOUT_ROOM,
		promise: JoinBreakoutRoom(sessionUuid, breakoutUuid, token, opentokId),
	};
}

export const GET_BREAKOUT_ROOM_USAGE = "GET_BREAKOUT_ROOM_USAGE";
export function getBreakoutRoomUsage(sessionUuid: string, breakoutUuid: string, token: string): AsyncAction {
	return {
		type: GET_BREAKOUT_ROOM_USAGE,
		promise: GetBreakoutRoomUsage(sessionUuid, token),
	};
}

export const LEAVE_BREAKOUT_ROOM = "LEAVE_BREAKOUT_ROOM";
export function leaveBreakoutRoom(sessionUuid: string, breakoutUuid: string, opentokId: string, token: string): AsyncAction {
	return {
		type: LEAVE_BREAKOUT_ROOM,
		promise: LeaveBreakoutRoom(sessionUuid, breakoutUuid, opentokId, token),
	};
}

export const GET_BREAKOUT_ROOM_TOKEN = "GET_BREAKOUT_ROOM_TOKEN";
export function getBreakoutRoomToken(opentokId: string, token: string): AsyncAction {
	return {
		type: GET_BREAKOUT_ROOM_TOKEN,
		promise: GetBreakoutRoomToken(opentokId, token),
	};
}

export const GET_OPENTOK_TOKEN = "GET_OPENTOK_TOKEN";
export function getOpenTokToken(opentokId: string, token: string, publisher: boolean): AsyncAction {
	return {
		type: GET_BREAKOUT_ROOM_TOKEN,
		promise: GetOpenTokToken(opentokId, token, publisher),
	};
}

export const GET_BREAKOUT_ROOM_TEST_INFO = "GET_BREAKOUT_ROOM_TEST_INFO";
export function getBreakoutRoomTestInfo(token: string, isFiresides?: boolean): AsyncAction {
	return {
		type: GET_BREAKOUT_ROOM_TOKEN,
		promise: GetBreakoutRoomTestInfo(token, isFiresides),
	};
}

export const TOGGLE_REPLAY_ON = "TOGGLE_REPLAY_ON";
export function toggleReplayOn(isOn: boolean): Action {
	return {
		type: TOGGLE_REPLAY_ON,
		payload: isOn
	};
}

export const TOGGLE_SESSION_FEEDBACK_SURVEY = "TOGGLE_SESSION_FEEDBACK_SURVEY";
export function toggleSessionFeedbackSurvey(isOn: boolean): Action {
	return {
		type: TOGGLE_SESSION_FEEDBACK_SURVEY,
		payload: isOn
	};
}

export const TOGGLE_REACTIONS = "TOGGLE_REACTIONS";
export function toggleReactions(enabled: boolean): Action {
	return {
		type: TOGGLE_REACTIONS,
		payload: enabled
	};
}

export const UPDATE_SECONDARY_SESSION_VIDEO = "UPDATE_SECONDARY_SESSION_VIDEO";
export function updateSecondarySessionVideo(secondaryVideo: Omit<SecondarySessionVideo, "id" | "uuid">, token: string): AsyncAction {
	return {
		type: UPDATE_SECONDARY_SESSION_VIDEO,
		promise: UpdateSecondarySessionVideo(secondaryVideo, token)
	};
}

export const GET_SECONDARY_SESSION_VIDEO = "GET_SECONDARY_SESSION_VIDEO";
export function getSecondarySessionVideo(sessionId: number, token: string): AsyncAction {
	return {
		type: GET_SECONDARY_SESSION_VIDEO,
		promise: GetSecondarySessionVideo(sessionId, token)
	};
}

export const DELETE_SECONDARY_SESSION_VIDEO = "DELETE_SECONDARY_SESSION_VIDEO";
export function deleteSecondarySessionVideo(sessionId: number, token: string): AsyncAction {
	return {
		type: DELETE_SECONDARY_SESSION_VIDEO,
		promise: DeleteSecondarySessionVideo(sessionId, token)
	};
}

export const TOGGLE_DISPLAY_SESSION_CHAT = "TOGGLE_DISPLAY_SESSION_CHAT";
export function toggleDisplaySessionChat(isOn: boolean): Action {
	return {
		type: TOGGLE_DISPLAY_SESSION_CHAT,
		payload: isOn
	};
}

export const SET_SESSION_CHAT_DARK_MODE = "SET_SESSION_CHAT_DARK_MODE";
export function setSessionChatDarkMode(isOn: boolean): Action {
	return {
		type: SET_SESSION_CHAT_DARK_MODE,
		payload: isOn
	};
}

export const SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE";
export function setCurrentLanguage(language: string): Action {
	return {
		type: SET_CURRENT_LANGUAGE,
		payload: language
	};
}

export const SET_SESSION_LOADING = "SET_SESSION_LOADING";
export function setSessionLoading(loading: boolean): Action {
	return {
		type: SET_SESSION_LOADING,
		payload: loading
	};
}

export const TOGGLE_EMBED_AUTOSCALE = "TOGGLE_EMBED_AUTOSCALE";
export function toggleEmbedAutoscale(isOn: boolean, sessionUuid: string, token: string): AsyncAction {
	return {
		type: TOGGLE_EMBED_AUTOSCALE,
		promise: ToggleEmbedAutoscale(isOn, sessionUuid, token)
	};
}